import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  selectedLanguage = 'en';
  segmentsNames: any = {};
  constantSegmentNames: any = {};
  language = {
    undefined: { en: '', es: '' },
    null: { en: '', es: '' },
    '': { en: '', es: '' },
    hello: { en: 'Hello', es: 'Hola' },
    world: { en: 'World', es: 'Mundo' }
  };

  // tslint:disable-next-line:variable-name
  constructor(private _http: HttpClient) { }

  getLang(value: string, args?: any): any {
    if (this.language[value]) {
      return this.language[value][this.selectedLanguage];
    }
    return value;
  }
  /**
   * @function that is used to toggle the selected language among 'en' and 'ch'
   */
  changeLanguage() {
    if (this.selectedLanguage === 'en') {
      this.selectedLanguage = 'es';
    } else {
      this.selectedLanguage = 'en';
    }
  }
}
